(() => {
  'use strict';
  const dialog = document.querySelector('[data-advisor-dialog]');
  if (!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready = '1';
  const root = window.Shopify?.routes?.root || '/';
  const node = (tag, text, className) => { const n = document.createElement(tag); if (text) n.textContent = text; if (className) n.className = className; return n; };
  const avatar = () => { const img = node('img', '', 'oliver-avatar'); img.src = dialog.dataset.avatarUrl; img.alt = ''; img.width = img.height = 36; return img; };
  let opener;
  function open(source) { opener = source || opener; if (!dialog.open) dialog.showModal(); document.documentElement.classList.add('oliver-open'); }
  dialog.addEventListener('close', () => { document.documentElement.classList.remove('oliver-open'); opener?.focus(); });
  document.addEventListener('click', e => {
    const trigger = e.target.closest('[data-advisor-open]');
    if (trigger) { e.preventDefault(); open(trigger); }
    if (e.target.closest('[data-advisor-close]')) dialog.close();
  });
  if (dialog.dataset.loggedIn !== 'true') return;
  const $ = s => dialog.querySelector(s);
  const form = $('[data-advisor-form]'), input = form.elements.query;
  const conversation = $('[data-advisor-conversation]'), status = $('[data-advisor-status]');
  const memory = $('[data-advisor-memory]'), starters = $('[data-advisor-starters]');
  const storageKey = 'wyper-oliver-tab-' + dialog.dataset.customerId;
  const returnKey = 'wyper-oliver-return-' + dialog.dataset.customerId;
  let session, initialization, initialized = false, busy = false, inspiration = null, compressing = false, records = [], hydrated = false, wardrobe = [], fittingGeneration = 0;
  const message = (text, type = 'status') => { status.dataset.noticeType = type; status.setAttribute('role', type === 'error' ? 'alert' : 'status'); status.setAttribute('aria-live', type === 'error' ? 'assertive' : 'polite'); status.textContent = text || ''; };
  async function api(path, body) {
    const response = await fetch(dialog.dataset.endpoint + path, {method: body === undefined ? 'GET' : 'POST', credentials:'same-origin', cache:'no-store', headers:body === undefined ? {} : {'Content-Type':'application/json'}, ...(body === undefined ? {} : {body:JSON.stringify({...body, csrf:session?.csrf})}), signal:AbortSignal.timeout(60000)});
    let data; try { data = await response.json(); } catch { console.warn('Oliver: respuesta no JSON',path,response.status); throw new Error([502,504].includes(response.status)?'Oliver ha tardado demasiado en responder. Tu mensaje sigue preparado para volver a intentarlo.':'No se ha podido conectar con Oliver. Inténtalo de nuevo.'); }
    if (!response.ok) throw new Error(data.error || 'No se ha podido completar la solicitud.');
    return data;
  }
  async function authenticate() {
    session = await window.WyperSession.get(true);
    if (!session.loggedIn) throw new Error('No se ha podido vincular tu sesión con Oliver. Tu cuenta sigue abierta; vuelve a intentarlo.');
    memory.checked = Boolean(session.memory);
  }
  function remember() {
    try { sessionStorage.setItem(storageKey, JSON.stringify({at:Date.now(), records:records.slice(-30), draft:input.value, variants:[...conversation.querySelectorAll('[data-oliver-variant]')].map(n=>({handle:n.dataset.oliverVariant,value:n.value}))})); } catch {}
  }
  function scroll() { conversation.scrollTop = conversation.scrollHeight; }
  function draw(role, text, data) {
    const article = node('article', '', 'w7-advisor__message w7-advisor__message--' + role);
    article.append(node('p', text));
    if (data?.outfits?.length) {
      const products = data.outfits.flatMap(o => o.products || []).filter((p,i,all) => all.findIndex(x => x.handle === p.handle) === i).slice(0,3);
      const proposal = node('section', '', 'w7-advisor__proposal');
      const grid = node('div', '', 'w7-advisor__products');
      products.forEach(p => grid.append(window.WyperProducts.card(p)));
      proposal.append(grid, window.WyperProducts.lookActions(products));
      article.append(proposal);
    }
    conversation.append(article); scroll(); return article;
  }
  function append(role, text, data) { records.push({role, text, ...(data ? {data} : {})}); draw(role, text, data); remember(); updateStarters(); }
  function updateStarters() {
    const texts = records.some(r => r.role === 'assistant') ? ['Otra opción', 'Cambiar colores', 'Un estilo más informal'] : ['Crear un conjunto', 'Combinar una prenda', 'Buscar para una ocasión'];
    starters.replaceChildren(...texts.map(t => { const b = node('button', t); b.type = 'button'; b.disabled = busy; return b; }));
  }
  async function initialize() {
    if (initialized) return;
    if (initialization) return initialization;
    initialization = (async () => {
      message('Conectando con tu espacio…');
      await authenticate();
      if (!hydrated) {
        let saved;
        try { saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch {}
        if (saved && Date.now() - saved.at < 86400000 && Array.isArray(saved.records)) {
          for (const r of saved.records.slice(-30)) if (['user','assistant'].includes(r.role) && typeof r.text === 'string') {
            // Revalidate product availability when returning to a conversation.
            const data = r.data ? await window.WyperProducts.verify(r.data) : undefined;
            records.push({...r, data}); draw(r.role, r.text, data);
          }
          input.value = String(saved.draft || '').slice(0,700);
          if(Array.isArray(saved.variants))window.WyperProducts.restoreVariants(saved.variants);
        } else if (session.memory) {
          const history = await api('/profile');
          for (const e of [...(history.events || [])].reverse().filter(e => e.kind === 'search').slice(-8)) {
            const p = e.payload || {};
            if (p.query) { records.push({role:'user', text:p.query}); draw('user',p.query); }
            if (p.reply || p.outfits?.length) { const data = await window.WyperProducts.verify({message:p.reply || '', outfits:p.outfits || []}); records.push({role:'assistant',text:data.message,data}); draw('assistant',data.message,data); }
          }
        }
        hydrated = true;
      }
      const space = await api('/space');
      renderProfile(space.state?.profile || {});
      renderFitting(space.state?.wardrobe || []);
      initialized = true; message(''); remember(); updateStarters();
    })();
    try { await initialization; } finally { initialization = null; }
  }
  function renderProfile(profile) {
    const box = $('[data-advisor-profile]'); box.replaceChildren();
    for (const [key,label] of [['style','Estilo'],['colors','Colores'],['brands','Marcas'],['usual','Talla'],['fit','Corte']]) {
      if (!profile[key]) continue;
      const row = node('div'); row.append(node('dt',label),node('dd',String(profile[key]))); box.append(row);
    }
    if (!box.childNodes.length) box.append(node('p','Cuéntame tus gustos durante la conversación o completa tu perfil.'));
  }
  async function renderFitting(items) {
    wardrobe = items;
    const generation = ++fittingGeneration;
    $('[data-fitting-count]').textContent = `Tu probador · ${items.length} de 3 prendas`;
    const box = $('[data-fitting-items]'); box.replaceChildren();
    const cards = await Promise.all(items.map(async item => {
      const p = await window.WyperProducts.product(item.handle).catch(() => null);
      const wrap = node('div','','oliver-fitting__item');
      const b = node('button', p ? '' : 'Prenda no disponible'); b.type = 'button'; b.setAttribute('aria-label',p?.title || item.handle);
      if (p) { const img = node('img'); img.src = window.WyperProducts.imageUrl(p.featured_image || p.images?.[0]); img.alt = p.title; img.width = 34; img.height = 42; b.append(img); b.addEventListener('click', () => window.WyperProducts.quick(item.handle).catch(e=>message(e.message, 'error'))); }
      else b.disabled = true;
      const remove = node('button','×'); remove.type = 'button'; remove.setAttribute('aria-label','Quitar '+(p?.title || item.handle)+' del probador');
      remove.addEventListener('click',async()=>{remove.disabled=true;try{await window.WyperSync.remove(item.handle);}catch(e){message(e.message, 'error');}finally{remove.disabled=false;}});
      wrap.append(b,remove); return wrap;
    }));
    if (generation === fittingGeneration) box.replaceChildren(...cards);
  }
  document.addEventListener('wyper:hydrate', e => renderFitting(e.detail.wardrobe || []));
  function markReturn() { remember(); try { sessionStorage.setItem(returnKey,location.pathname); } catch {} }
  document.addEventListener('click', e => {
    if (dialog.open && e.target.closest('[data-oliver-leave]')) markReturn();
    if (e.target.closest('[data-advisor-settings]')) {
      const panel = $('#OliverPreferences'); panel.hidden = !panel.hidden;
      $('[aria-controls="OliverPreferences"]').setAttribute('aria-expanded',String(!panel.hidden));
    }
  });
  window.addEventListener('pagehide',remember);
  input.addEventListener('input',remember);
  conversation.addEventListener('change',remember);
  input.addEventListener('keydown', e => { if (e.key === 'Enter' && !e.shiftKey && !e.isComposing && !busy) { e.preventDefault(); form.requestSubmit(); } });
  document.addEventListener('click', e => {
    const trigger = e.target.closest('[data-advisor-open]'); if (!trigger) return;
    initialize().then(()=>{ if(trigger.dataset.oliverPrompt) input.value=trigger.dataset.oliverPrompt; input.focus(); }).catch(e=>message(e.message, 'error'));
  });
  try { if (sessionStorage.getItem(returnKey) === location.pathname) { sessionStorage.removeItem(returnKey); open(); initialize().catch(e=>message(e.message, 'error')); } } catch {}
  function removeInspiration() { inspiration=null; $('[data-inspiration]').value=''; $('[data-attachment]').hidden=true; }
  $('[data-remove-inspiration]').addEventListener('click',removeInspiration);
  $('[data-inspiration]').addEventListener('change',async e=>{
    const file=e.target.files?.[0]; removeInspiration(); if(!file)return;
    compressing=true; const send=form.querySelector('[type="submit"]');send.disabled=true;
    try{ inspiration=await window.WyperProducts.compress(file); $('[data-attachment-name]').textContent=file.name; $('[data-attachment]').hidden=false;message('Foto preparada. Se enviará junto con tu próximo mensaje.'); }
    catch(err){message(err.message, 'error');}finally{compressing=false;send.disabled=busy;}
  });
  starters.addEventListener('click',e=>{const b=e.target.closest('button');if(!b||busy)return;input.value=b.textContent;input.focus();form.requestSubmit();});
  document.addEventListener('oliver:refine', e=>{if(busy)return;input.value=e.detail;form.requestSubmit();});
  memory.addEventListener('change',async()=>{const enabled=memory.checked;memory.disabled=true;try{await authenticate();await api('/memory',{enabled});session.memory=enabled;memory.checked=enabled;message(enabled?'Oliver recordará tus preferencias.':'Memoria guardada eliminada.');}catch(e){memory.checked=Boolean(session?.memory);message(e.message, 'error');}finally{memory.disabled=false;}});
  $('[data-advisor-clear]').addEventListener('click',async()=>{
    if(busy||!window.confirm('¿Borrar esta conversación y la memoria de Oliver? Tus prendas del probador se conservarán.'))return;
    const b=$('[data-advisor-clear]');b.disabled=true;
    try{await authenticate();await api('/memory',{enabled:false});session.memory=false;memory.checked=false;records=[];conversation.querySelectorAll('article:not(.oliver-welcome)').forEach(n=>n.remove());input.value='';removeInspiration();remember();updateStarters();message('Conversación y memoria eliminadas.');}catch(e){message(e.message, 'error');}finally{b.disabled=false;}
  });
  form.addEventListener('submit',async e=>{
    e.preventDefault(); if(busy||compressing)return;
    const query=input.value.trim();if(!query)return;
    busy=true;form.querySelector('[type="submit"]').disabled=true;memory.disabled=true;$('[data-advisor-clear]').disabled=true;$('[data-inspiration]').disabled=true;
    try {
      await initialize();
      append('user',query);input.value='';remember();
      message('Oliver está pensando…');status.classList.add('is-thinking');status.setAttribute('aria-busy','true');
      await authenticate();
      const data = await window.WyperProducts.verify(await api('/search',{query,anchor:null,inspiration,context:records.slice(-12).map(r=>({role:r.role,text:r.text+(r.data?.outfits? ' Prendas: '+r.data.outfits.flatMap(o=>o.products.map(p=>p.title+' ('+p.handle+')')).join(', '):'')}))}));
      append('assistant',data.message || 'Estas son mis propuestas.',data);removeInspiration();message('');
    } catch(err) { message(err.message || 'No he podido responder. Inténtalo de nuevo.', 'error'); if(!input.value)input.value=query; remember(); }
    finally { busy=false;form.querySelector('[type="submit"]').disabled=false;memory.disabled=false;$('[data-advisor-clear]').disabled=false;$('[data-inspiration]').disabled=false;status.classList.remove('is-thinking');status.setAttribute('aria-busy','false');updateStarters(); }
  });
})();
